import { observable, autorun, toJS, set } from 'mobx';

// Imports => Utilities
import {
  AcIsSet,
  AcIsUndefined,
  AcIsNull,
  AcGetState,
} from '@opp/ui-kit';

const _type_of_storage = process.env.APP_STORAGE || 'local';
const _storage = window[`${_type_of_storage}Storage`];

export const AcAutoSave = (store, callback, key) => {
  if (!store || !key) return;

  let firstRun = true;

  autorun(() => {
    // This code will run every time any observable property
    // in the provided store is updated
    const data = JSON.stringify(toJS(store));

    if (!firstRun && callback) {
      callback(data);
    }
    firstRun = false;
  });
};

export const AcAutoLoad = (store, key) => {
  if (!AcIsSet(store) || !AcIsSet(key)) return;

  const data = AcGetState(key);

  if (data && store) set(store, { [key]: data });
};

export default {
  AcAutoLoad,
  AcAutoSave,
};
